import { render, staticRenderFns } from "./createCustom.vue?vue&type=template&id=7c2c8e8d&scoped=true&"
import script from "./createCustom.vue?vue&type=script&lang=js&"
export * from "./createCustom.vue?vue&type=script&lang=js&"
import style0 from "./createCustom.vue?vue&type=style&index=0&id=7c2c8e8d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2c8e8d",
  null
  
)

export default component.exports